import { faBasketShopping } from "@fortawesome/pro-solid-svg-icons";
import { useMutation } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { T } from "@repo/transifex";
import { toast } from "~/components/hooks/use-toast";
import { logger } from "~/services/logger";
import { kioskActions } from "~/stores/kiosk-session/actions";
import { useKioskProducts } from "~/stores/kiosk-session/hooks/use-kiosk-products";
import { getIsAddDisabled } from "~/stores/kiosk-session/hooks/use-kiosk-products/get-is-add-disabled";

export function useFindProductKiosk() {
  const [searchParams] = useSearchParams();
  const discountId = searchParams.get("discount");

  const { productsList } = useKioskProducts();

  return useMutation({
    mutationFn: async (barcode: string) => {
      const item = productsList.find(({ product }) =>
        product.barcodeIds.includes(barcode)
      );
      if (!item) {
        throw new Error("Barcode not registered");
      }

      if (getIsAddDisabled(item)) {
        // TO-DO: [POS-2404] Add a toast to inform the user that the product is unavailable
        throw new Error("Product is unavailable");
      }

      const discount = item.discounts.find(
        (discount) => discount.id === discountId
      );

      kioskActions.basket.add(item, { quantity: 1, discount });

      return Promise.resolve(item.product);
    },
    onError: (_, barcode) => {
      logger.warn("[Product Barcode] Barcode not registered", {
        product_barcode: barcode
      });
    },
    onSuccess: (product, barcode) => {
      logger.debug("[Product Barcode] Product added to basket", {
        product_barcode: barcode,
        product_barcodes: product.barcodeIds,
        product_id: product.id
      });
      toast({
        title: product.name,
        description: <T _str="Added to basket" />,
        variant: "success",
        icon: faBasketShopping,
        toastDuration: "default"
      });
    }
  });
}
